import React, {useContext, useState} from 'react';
import Transition from "components/Transition";
import {SimpleLogo} from "components/logos";
import {AuthContext} from "contexts/auth/auth.provider";
import {useRouter} from "next/router";
import {SearchContext} from "contexts/search/search.provider";
import BlockUi from "react-block-ui";
import Link from "next/link";

export default function AdminContainer({children}) {
    const router = useRouter();

    const [showMenu, setShowMenu] = useState(false);
    const [profileMenu, setProfileMenu] = useState(false);

    const {user, logout, loading} = useContext(AuthContext);

    function onSignout() {
        logout().then(() => window.location.href = process.env.BASE_URL);
    }

    function toggleMenu() {
        setShowMenu(d => !d);
    }

    function toggleProfileMenu() {
        setProfileMenu(d => !d);
    }

    function getMenuItemClass(route) {

        if (new RegExp(`^\/admin\/${route}`).test(router.pathname)) {
            return "group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-white bg-indigo-700 focus:outline-none focus:bg-indigo-700 transition ease-in-out duration-150";
        }
        return "group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-indigo-300 hover:text-white hover:bg-indigo-700 focus:outline-none focus:text-white focus:bg-indigo-700 transition ease-in-out duration-150";
    }


    return (
        <>
            <div className="h-screen flex overflow-hidden bg-gray-100">
                {/* Off-canvas menu for mobile, show/hide based on off-canvas menu state. */}
                <div className="md:hidden">
                    <Transition show={showMenu}>
                        <div className="fixed inset-0 flex z-40">
                            <Transition
                                show={showMenu}
                                enter="transition-opacity ease-linear duration-300"
                                enterFrom="opacity-0"
                                enterTo="opacity-100"
                                leave="transition-opacity ease-linear duration-300"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                                appear={true}
                            >
                                <div className="fixed inset-0">
                                    <div className="absolute inset-0 bg-gray-600 opacity-75"/>
                                </div>
                            </Transition>
                            <Transition
                                show={showMenu}
                                enter="transition ease-in-out duration-300 transform"
                                enterFrom="-translate-x-full"
                                enterTo="translate-x-0"
                                leave="transition ease-in-out duration-300 transform"
                                leaveFrom="translate-x-0"
                                leaveTo="-translate-x-full"
                                appear={true}
                            >
                                <div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-indigo-800">
                                    <div className="absolute top-0 right-0 -mr-14 p-1">
                                        <button
                                            onClick={toggleMenu}
                                            className="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                                            aria-label="Close sidebar"
                                        >
                                            <svg
                                                className="h-6 w-6 text-white"
                                                stroke="currentColor"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M6 18L18 6M6 6l12 12"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="flex-shrink-0 flex items-center px-4">
                                        <SimpleLogo
                                            className="h-8 w-auto"
                                        />
                                    </div>
                                    <div className="mt-5 flex-1 h-0 overflow-y-auto">
                                        <nav className="px-2 space-y-1">
                                            <Link href="/admin/dashboard" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`dashboard`)}
                                                >
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                                        />
                                                    </svg>
                                                    Dashboard
                                                </a>
                                            </Link>

                                            <Link href="/admin/products" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`products`)}>
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                                                        />
                                                    </svg>
                                                    Products
                                                </a>
                                            </Link>

                                            <Link href="/admin/orders" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`orders`)}
                                                >
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                        />
                                                    </svg>
                                                    Orders
                                                </a>
                                            </Link>

                                            <div className="mt-16">
                                                <h3 className="mt-8 px-3 text-xs leading-4 font-semibold text-white uppercase tracking-wider">
                                                    Settings
                                                </h3>
                                                <div className="mt-1 space-y-1" role="group">


                                                    <Link href="/admin/categories" prefetch={false}>
                                                        <a
                                                            className={getMenuItemClass(`categories`)}
                                                        >
                                                            <svg
                                                                className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                                fill="none" stroke="currentColor"
                                                                viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                                      strokeWidth={2}
                                                                      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                                                            </svg>
                                                            Categories
                                                        </a>
                                                    </Link>

                                                    <Link href="/admin/coupons" prefetch={false}>
                                                        <a
                                                            className={getMenuItemClass(`coupons`)}
                                                        >
                                                            <svg
                                                                className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth={2}
                                                                    d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                                                                />
                                                            </svg>
                                                            Coupons
                                                        </a>
                                                    </Link>
                                                </div>
                                            </div>
                                        </nav>
                                    </div>

                                </div>
                            </Transition>

                            <div className="flex-shrink-0 w-14">
                                {/* Dummy element to force sidebar to shrink to fit close icon */}
                            </div>
                        </div>
                    </Transition>
                </div>
                {/* Static sidebar for desktop */}
                <div className="hidden md:flex md:flex-shrink-0">
                    <div className="flex flex-col w-64">
                        {/* Sidebar component, swap this element with another sidebar if you like */}
                        <div
                            className="flex flex-col flex-grow border-r border-gray-200 pb-4 bg-scuttle-blue overflow-y-auto">
                            <div className="flex items-center justify-center flex-shrink-0 p-4">
                                <SimpleLogo
                                    className="h-14 w-auto"
                                />
                            </div>
                            <div className="mt-5 flex-grow flex flex-col">
                                <nav className="px-2 space-y-1">
                                    <Link href="/admin/dashboard" prefetch={false}>
                                        <a
                                            className={getMenuItemClass(`dashboard`)}
                                        >
                                            <svg
                                                className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                                                />
                                            </svg>
                                            Dashboard
                                        </a>
                                    </Link>

                                    <Link href="/admin/products" prefetch={false}>
                                        <a
                                            className={getMenuItemClass(`products`)}>
                                            <svg
                                                className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                                                />
                                            </svg>
                                            Products
                                        </a>
                                    </Link>

                                    <Link href="/admin/orders" prefetch={false}>
                                        <a
                                            className={getMenuItemClass(`orders`)}
                                        >
                                            <svg
                                                className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                                                />
                                            </svg>
                                            Orders
                                        </a>
                                    </Link>

                                    <div className="mt-16">
                                        <h3 className="mt-8 px-3 text-xs leading-4 font-semibold text-white uppercase tracking-wider">
                                            Settings
                                        </h3>
                                        <div className="mt-1 space-y-1" role="group">

                                            <Link href="/admin/categories" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`categories`)}
                                                >
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none" stroke="currentColor"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              strokeWidth={2}
                                                              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                                                    </svg>
                                                    Categories
                                                </a>
                                            </Link>

                                            <Link href="/admin/coupons" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`coupons`)}
                                                >
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
                                                        />
                                                    </svg>
                                                    Coupons
                                                </a>
                                            </Link>
                                            <Link href="/admin/locations" prefetch={false}>
                                                <a
                                                    className={getMenuItemClass(`locations`)}
                                                >
                                                    <svg
                                                        className="mr-4 h-6 w-6 text-indigo-400 group-hover:text-indigo-300 group-focus:text-indigo-300 transition ease-in-out duration-150"
                                                        fill="none" stroke="currentColor"
                                                        viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              strokeWidth={2}
                                                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                                                    </svg>

                                                    Locations
                                                </a>
                                            </Link>
                                        </div>
                                    </div>

                                </nav>
                            </div>
                            <div className="flex-shrink-0 flex p-4">
                                <a href="/rent/" className="flex-shrink-0 group block">
                                    <div className="flex items-center">
                                        <div className="ml-3 flex  flex-row gap-2">
                                            <p className="text-sm leading-5 font-medium text-indigo-300 group-hover:text-indigo-100 transition ease-in-out duration-150">
                                                Visit Shop
                                            </p>
                                            <svg className="w-5 h-5  text-indigo-300" fill="none" stroke="currentColor"
                                                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
                                            </svg>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col w-0 flex-1 overflow-hidden">

                    <main className="flex-1 relative overflow-y-auto focus:outline-none" tabIndex={0}>
                        <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
                            <button
                                onClick={toggleMenu}
                                className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600 md:hidden"
                                aria-label="Open sidebar">
                                <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M4 6h16M4 12h16M4 18h7"/>
                                </svg>
                            </button>
                            <div className="flex-1 px-4 flex justify-between">
                                <div/>
                                <div className="ml-4 flex items-center md:ml-6">
                                    <button
                                        className="p-1 text-gray-400 rounded-full hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:shadow-outline focus:text-gray-500"
                                        aria-label="Notifications"
                                    >
                                        <svg
                                            className="h-6 w-6"
                                            stroke="currentColor"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                                            />
                                        </svg>
                                    </button>
                                    {/* Profile dropdown */}
                                    <div className="ml-3 relative">
                                        <div>
                                            <button
                                                onClick={toggleProfileMenu}
                                                className="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline"
                                                id="user-menu"
                                                aria-label="User menu"
                                                aria-haspopup="true"
                                            >
                                                {
                                                    user?.attributes?.picture ?
                                                        <img
                                                            className="h-10 w-10 rounded-full"
                                                            src={user?.attributes?.picture}
                                                        />
                                                        :
                                                        <span
                                                            className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                                                  <span className="font-medium leading-none text-white">
                                                      {user?.attributes?.given_name && user?.attributes?.given_name[0]}{user?.attributes?.family_name && user?.attributes?.family_name[0]}
                                                  </span>
                                                </span>
                                                }
                                            </button>
                                        </div>


                                        <Transition
                                            show={profileMenu}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                            appear={true}
                                        >
                                            <div
                                                className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                                                <div
                                                    className="py-1 rounded-md bg-white shadow-xs"
                                                    role="menu"
                                                    aria-orientation="vertical"
                                                    aria-labelledby="user-menu"
                                                >
                                                    <p className="block px-4 py-2 text-sm text-gray-700 border-b"
                                                       role="menuitem">{user?.attributes.email}</p>
                                                    <a
                                                        href="/rent/"
                                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                                                        role="menuitem"
                                                    >
                                                        Visit Store
                                                    </a>
                                                    <a
                                                        onClick={onSignout}
                                                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150"
                                                        role="menuitem"
                                                    >
                                                        Sign out
                                                    </a>
                                                </div>
                                            </div>
                                        </Transition>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="max-w-7xl mx-auto sm:px-6 md:px-8 pt-2 pb-6 md:py-6">
                            {children}
                        </div>
                    </main>
                </div>
            </div>
        </>
    )
        ;
}